import { useState, useEffect, useRef } from 'react';

export default function ColumnSettings({ columns, visible, onChange }) {
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const toggle = (key) => {
    onChange({ ...visible, [key]: !visible[key] });
  };

  return (
    <div className="col-settings" ref={boxRef}>
      <button type="button" className="btn-secondary btn-sm" onClick={() => setOpen(o => !o)}>⚙ Столбцы</button>
      {open && (
        <div className="col-settings-list">
          {columns.map(col => (
            <label key={col.key} className="col-settings-item">
              <input
                type="checkbox"
                checked={visible[col.key] !== false}
                onChange={() => toggle(col.key)}
              />
              {col.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
